import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ImageOff } from "lucide-react";
import { thumbUrl } from "@/lib/product";

/** Consistent image container with graceful fallback for missing CRM photos. */
export const ProductImage = ({ src, alt, className = "", imgClassName = "", width = 720 }) => {
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-1 bg-muted text-muted-foreground ${className}`}
        data-testid="product-image-fallback"
      >
        <ImageOff className="h-6 w-6" aria-hidden="true" />
        <span className="text-[11px]">{t("product.noImage")}</span>
      </div>
    );
  }

  return (
    <div className={`overflow-hidden bg-muted ${className}`}>
      <img
        src={thumbUrl(src, width, { alpha: true })}
        alt={alt}
        loading="lazy"
        onError={() => setFailed(true)}
        className={`h-full w-full object-contain ${imgClassName}`}
        data-testid="product-image"
      />
    </div>
  );
};
